import { Alert, AlertIcon, AlertTitle } from "@/components/elements/Alert";
import cn from "@/helpers/classNames";
import { useIntegrationDocumentationUrl } from "@/integrations/documentation/useIntegrationDocumentation";
import { useMixpanel } from "@/monitoring/mixpanel";
import { ExternalLinkIcon } from "@/components/icons/domain-icons";
import { ComponentProps } from "@tw-classed/react";

type Props = {
  integrationId: string;
};

const IPWhitelistInfo = ({
  integrationId,
  ...props
}: Props & ComponentProps<typeof Alert>) => {
  const mixpanel = useMixpanel();

  const documentationUrl = useIntegrationDocumentationUrl(integrationId, false);

  return (
    <Alert
      status="info"
      {...props}
      className={cn("items-start", props.className)}
    >
      <AlertIcon />
      <div className="leading-normal">
        <AlertTitle className="mb-2">Whitelist Weld's IP pool</AlertTitle>
        <div className="space-y-2">
          <p>Requests from Weld will always come from the following IP pool:</p>
          <ul className="list-inside list-disc">
            <li>3.64.84.139</li>
            <li>3.65.119.169</li>
            <li>35.156.133.78</li>
          </ul>
          <p>
            Make sure to whitelist all three of these IP's within your network
            policies, SSH gateway server or the DB itself. If any updates to the
            list are ever scheduled to happen, you will be contacted by Weld via
            email.
            {documentationUrl && (
              <a
                href={documentationUrl}
                target="_blank"
                rel="noreferrer"
                onClick={() => {
                  mixpanel.track("Connector Setup Documentation Viewed", {
                    integration_id: integrationId,
                  });
                }}
                className="ml-1 inline-flex items-center text-sm underline"
              >
                View full setup guide
                <ExternalLinkIcon className="ml-1 size-4" />
              </a>
            )}
          </p>
        </div>
      </div>
    </Alert>
  );
};

export default IPWhitelistInfo;
